export default __webpack_public_path__ + "images/2628cc3ffc1ba71bf33faae190fabd7f-film_and_media.jpg";